import { Module } from "vuex";
import { RecoveryState, state } from "./state";
import { mutations } from "./mutations";
import { actions } from "./actions";
import { getters } from "./getters";

const recovery: Module<RecoveryState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default recovery;
